var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 247,
    viewBox: "0 0 239 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.296 212.538C206.389 217.809 201.746 221.209 198.077 223.895C154.95 255.468 103.921 246.264 93.0754 244.017C77.0605 240.698 46.1039 234.283 23.7224 207.428C-10.1385 166.799 -4.86587 102.788 21.3989 60.5339C26.2031 52.8044 51.5806 9.90679 103.16 3.02786C134.375 -1.13548 170.762 7.26118 197.113 29.7869C252.425 77.0694 248.487 172.589 211.296 212.538",
    fill: "#EBF3FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.377 222.845H90.6965V115.201C90.6965 113.416 92.2663 111.97 94.2019 111.97H156.872C158.808 111.97 160.377 113.416 160.377 115.201V222.845Z",
    fill: "#89342E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.677 222.845H72.9961V115.201C72.9961 113.416 74.5658 111.97 76.5015 111.97H139.171C141.107 111.97 142.677 113.416 142.677 115.201V222.845Z",
    fill: "#B5453C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6678 132.701C77.4232 132.701 77.2246 132.518 77.2246 132.292V124.426C77.2246 120.221 81.0535 116.8 85.7592 116.8H99.1408C99.3853 116.8 99.5839 116.982 99.5839 117.208C99.5839 117.433 99.3853 117.615 99.1408 117.615H85.7592C81.5418 117.615 78.1101 120.671 78.1101 124.426V132.292C78.1101 132.518 77.9123 132.701 77.6678 132.701Z",
    fill: "url(#paint0_linear_3061_1304)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6678 141.042C77.4232 141.042 77.2246 140.859 77.2246 140.633V137.429C77.2246 137.203 77.4232 137.02 77.6678 137.02C77.9123 137.02 78.1101 137.203 78.1101 137.429V140.633C78.1101 140.859 77.9123 141.042 77.6678 141.042Z",
    fill: "url(#paint1_linear_3061_1304)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9171 222.686H21.8743V155.846C21.8743 154.062 23.4438 152.615 25.38 152.615H78.4109C80.3474 152.615 81.9171 154.062 81.9171 155.846V222.686",
    fill: "#233862"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.216 222.686H4.17358V155.846C4.17358 154.062 5.74321 152.615 7.67943 152.615H60.7106C62.6471 152.615 64.216 154.062 64.216 155.846V222.686",
    fill: "#6160EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1299 172.636C8.88551 172.636 8.68726 172.453 8.68726 172.228V163.924C8.68726 159.497 13.1687 155.895 18.6768 155.895H34.4647C34.7091 155.895 34.9073 156.077 34.9073 156.303C34.9073 156.528 34.7091 156.711 34.4647 156.711H18.6768C13.6567 156.711 9.57254 159.946 9.57254 163.924V172.228C9.57254 172.453 9.37429 172.636 9.1299 172.636Z",
    fill: "#91B3FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1299 181.441C8.88551 181.441 8.68726 181.258 8.68726 181.033V177.649C8.68726 177.425 8.88551 177.242 9.1299 177.242C9.3743 177.242 9.57255 177.425 9.57255 177.649V181.033C9.57255 181.258 9.3743 181.441 9.1299 181.441Z",
    fill: "#91B3FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M229.932 222.686H169.889V154.731C169.889 152.946 171.459 151.499 173.395 151.499H226.427C228.362 151.499 229.932 152.946 229.932 154.731V222.686",
    fill: "#233862"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M212.231 222.686H152.188V154.731C152.188 152.946 153.758 151.499 155.695 151.499H208.725C210.662 151.499 212.231 152.946 212.231 154.731V222.686",
    fill: "url(#paint2_linear_3061_1304)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.145 171.833C156.901 171.833 156.703 171.651 156.703 171.425V162.989C156.703 158.495 161.184 154.839 166.692 154.839H182.48C182.724 154.839 182.922 155.021 182.922 155.246C182.922 155.472 182.724 155.655 182.48 155.655H166.692C161.672 155.655 157.588 158.945 157.588 162.989V171.425C157.588 171.651 157.389 171.833 157.145 171.833",
    fill: "#91B3FA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.145 180.778C156.901 180.778 156.703 180.595 156.703 180.37V176.933C156.703 176.708 156.901 176.525 157.145 176.525C157.389 176.525 157.588 176.708 157.588 176.933V180.37C157.588 180.595 157.389 180.778 157.145 180.778Z",
    fill: "#91B3FA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65218 168.158C9.67819 168.149 23.6777 145.553 25.5694 143.426C25.8877 143.069 26.3802 142.886 26.8786 142.941L30.7861 143.371L35.3766 152.524L27.729 148.418C28.4857 153.242 18.6614 160.411 15.292 163.027C14.9501 163.292 14.922 163.768 15.2308 164.065L16.5759 165.363C14.3676 167.426 11.8192 168.751 8.94312 169.364L9.65218 168.158Z",
    fill: "#8D491C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7977 164.663C15.7977 164.663 16.6561 164.918 16.9468 165.623C17.086 165.961 16.936 166.343 16.6178 166.553C15.2043 167.486 10.5413 170.5 8.38948 171.09C8.21308 171.139 8.04527 170.991 8.08499 170.825C8.19539 170.365 8.55252 169.445 9.70327 168.098L9.60015 168.291C9.46946 168.534 9.75721 168.788 10.014 168.654C11.4532 167.905 14.3847 166.266 15.7977 164.663",
    fill: "url(#paint3_linear_3061_1304)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1052 173.704C15.1286 173.69 17.229 169.025 17.2525 169.012C19.1783 158.205 23.8768 148.95 25.2625 146.515C25.4957 146.105 25.938 145.835 26.4382 145.796L30.359 145.487L36.8643 153.595L28.4736 151.001C30.2738 155.583 22.2268 164.437 19.5015 167.627C19.2249 167.95 19.3019 168.421 19.6697 168.655L21.272 169.675C19.5623 172.108 17.3577 173.88 14.6755 175.016L15.1052 173.704",
    fill: "#B26634"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.356 169.134C20.356 169.134 21.2529 169.225 21.6922 169.861C21.9024 170.165 21.8395 170.567 21.574 170.832C20.3947 172.009 16.49 175.831 14.5122 176.81C14.3501 176.89 14.1535 176.777 14.156 176.608C14.163 176.136 14.3107 175.168 15.1419 173.635L15.0831 173.843C15.0086 174.106 15.3462 174.3 15.5682 174.122C16.8133 173.12 19.3242 170.968 20.356 169.134",
    fill: "url(#paint4_linear_3061_1304)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7121 143.78C48.7121 143.78 52.2592 148.642 52.5497 150.86C52.8411 153.078 51.5688 153.845 47.857 154.128C36.8091 154.97 31.363 151.918 31.363 151.918C30.6072 147.477 30.0695 146.347 23.7578 143.933C23.7578 143.933 31.741 144.516 33.3477 143.942C34.9544 143.367 48.7121 143.78 48.7121 143.78",
    fill: "url(#paint5_linear_3061_1304)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2294 114.793C35.2294 114.793 37.5689 114.779 38.4363 115.593C39.1323 116.246 41.2717 115.396 42.2994 116.836C42.83 117.578 43.8051 117.923 44.7251 117.654C47.0168 116.985 50.8457 116.511 53.1977 119.68C54.9937 122.099 54.0831 123.741 52.7562 124.77C51.7815 125.526 51.5768 126.856 52.3547 127.786C53.1005 128.678 53.3928 129.969 52.0173 131.721C48.9343 135.648 41.1071 130.711 41.1071 130.711L33.8591 119.169L35.2294 114.793",
    fill: "url(#paint6_linear_3061_1304)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1197 143.136C39.1197 143.136 34.9893 139.511 32.9561 137.11C31.8571 135.813 31.512 134.104 32.0203 132.526C32.9485 129.643 34.5982 126.658 34.7487 126.193C34.9793 125.481 39.6105 125.511 39.6105 125.511C39.6105 125.511 48.7236 130.962 52.3045 140.197L48.2831 141.35C48.2831 141.35 45.9042 137.671 43.5527 135.331C43.5527 135.331 47.6214 140.285 47.7645 142.313L39.1197 143.136",
    fill: "#233862"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1885 122.213C34.2368 122.361 35.4455 126.055 35.5401 126.131C35.6347 126.208 38.1911 126.334 39.3943 125.577L36.9384 120.569L34.1885 122.213Z",
    fill: "#8D491C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8639 118.065C30.8639 118.065 30.0034 119.897 31.0145 122.681C32.0256 125.467 33.6781 125.709 34.7245 125.021C35.771 124.332 37.1279 123.102 37.2966 120.578C37.4654 118.055 32.0495 115.747 30.8639 118.065",
    fill: "#B26634"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2545 120.415C35.2545 120.415 33.4285 116.644 30.6897 118.993L30.4783 119.963C30.4783 119.963 27.8702 119.278 28.7274 117.1C29.5846 114.922 32.7014 113.444 35.491 114.856C38.2806 116.268 39.2288 117.931 39.0788 119.914C38.9289 121.896 37.3163 121.218 37.3163 121.218C37.3163 121.218 37.006 119.76 36.2485 119.501C35.4909 119.242 35.5072 120.346 35.5072 120.346L35.2545 120.415",
    fill: "url(#paint7_linear_3061_1304)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8824 120.46C35.8824 120.46 34.9314 118.527 36.2635 118.458C37.5956 118.387 37.0536 120.321 36.7882 121.026L35.8824 120.46Z",
    fill: "#B26634"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 144.566L34.3536 141.454L37.9379 142.343C37.9379 142.343 42.1168 142.94 44.5084 142.343C46.8998 141.747 46.8998 141.747 46.8998 141.747L52.3045 140.196L53.1535 142.407C53.3694 142.968 53.1526 143.592 52.6262 143.936C52.1579 144.243 51.6098 144.579 51.2612 144.721C50.5492 145.007 34.8651 144.811 34.8651 144.811L31.25 144.566",
    fill: "#B26634"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5233 145.798C41.5124 145.799 41.5015 145.799 41.4905 145.799L27.2153 145.785C26.8623 145.785 26.5766 145.52 26.5769 145.195C26.5773 144.869 26.8647 144.601 27.2166 144.606L41.4919 144.621C41.8448 144.622 42.1305 144.885 42.1302 145.211C42.1297 145.526 41.8609 145.783 41.5233 145.798Z",
    fill: "#91B3FA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3825 133.853H26.271C27.1479 133.853 27.9463 134.319 28.3204 135.05L33.8164 145.791H19.0422C18.477 145.791 17.9692 145.473 17.7615 144.989L13.4995 135.049C13.2533 134.475 13.7125 133.853 14.3825 133.853",
    fill: "#91B3FA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7578 139.36C23.0155 140.097 22.8251 140.814 22.3327 140.96C21.8404 141.106 21.2324 140.627 20.9747 139.889C20.7171 139.151 20.9074 138.435 21.3998 138.289C21.8922 138.142 22.5003 138.622 22.7578 139.36Z",
    fill: "#BDD0FB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M148.325 5.30496C158.453 2.53934 168.11 3.2851 172.932 4.46089C178.633 5.85009 180.524 6.8924 185.571 7.41675C190.056 7.88355 201.976 4.53842 200.45 7.05466C198.46 10.3342 199.005 23.1792 201.975 28.5338C202.407 29.3131 188.291 31.2419 179.738 29.8015C167.946 27.8152 164.15 24.4853 156.406 26C152.835 26.6994 150.12 28.0966 148.386 29.1676C149.176 21.2489 147.536 13.2246 148.325 5.30496",
    fill: "#F99746"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.453 111.838C148.209 111.838 148.01 111.656 148.01 111.43V2.75921C148.01 2.53381 148.209 2.35077 148.453 2.35077C148.697 2.35077 148.896 2.53381 148.896 2.75921V111.43C148.896 111.656 148.697 111.838 148.453 111.838Z",
    fill: "#26264F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.755 111.864C97.7541 111.808 97.7585 111.751 97.7741 111.693C98.6994 108.312 102.482 106.579 102.482 106.579L104.303 106.711C105.349 109.691 106.023 111.146 105.855 111.959C105.851 111.982 105.843 112.004 105.837 112.026C104.336 112.149 101.246 112.23 97.755 111.864",
    fill: "url(#paint8_linear_3061_1304)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M105.859 112.026C105.778 112.298 105.56 112.51 105.281 112.563C103.146 112.978 99.7514 112.644 98.3266 112.473C98.0117 112.435 97.7828 112.167 97.7776 111.864C101.267 112.23 104.357 112.149 105.859 112.026",
    fill: "url(#paint9_linear_3061_1304)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M100.984 103.968L101.781 107.504C101.839 107.764 102.056 107.957 102.317 107.98C102.637 108.007 103.093 108.024 103.552 107.962C103.963 107.906 104.249 107.521 104.176 107.108L103.622 103.968H100.984Z",
    fill: "#B26634"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.276 111.997C119.332 111.947 118.326 111.736 117.807 111.54C117.806 111.718 117.807 111.899 117.813 112.087C117.82 112.288 117.981 112.448 118.18 112.447L128.851 112.384C129.192 112.381 129.39 112.018 129.243 111.729C127.844 111.836 124.28 112.074 121.276 111.997",
    fill: "url(#paint10_linear_3061_1304)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M129.267 111.729C129.255 111.705 129.244 111.679 129.226 111.656C128.283 110.442 125.882 108.024 121.139 106.976L118.864 106.91C118.864 106.91 117.85 108.534 117.831 111.54C118.351 111.736 119.356 111.947 121.3 111.997C124.305 112.075 127.868 111.836 129.267 111.729Z",
    fill: "url(#paint11_linear_3061_1304)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M118.441 103.732C118.467 103.888 118.779 106.264 118.899 107.185C118.928 107.404 119.101 107.573 119.317 107.597C119.705 107.64 120.332 107.679 120.88 107.575C121.176 107.519 121.39 107.258 121.39 106.952V103.223L118.441 103.732Z",
    fill: "#B26634"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M102.505 57.5443C102.505 57.5443 98.8634 87.3756 100.887 106.02C100.887 106.02 103.314 106.02 104.527 105.647C104.527 105.647 108.311 76.4793 109.536 68.1337C109.582 67.8187 110.069 67.8043 110.136 68.1161C111.646 75.1381 117.578 102.674 118.284 105.274C118.284 105.274 120.306 106.02 121.924 105.274C121.924 105.274 118.688 65.3752 116.26 58.2901L102.505 57.5443",
    fill: "url(#paint12_linear_3061_1304)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2219 22.8655C95.2219 22.8655 107.463 21.342 118.634 22.8958C121.398 23.2811 123.323 25.6263 122.949 28.1793L121.924 35.1709C121.924 35.1709 118.688 51.2051 116.26 58.2902C116.26 58.2902 106.955 59.7817 102.505 57.5444C102.505 57.5444 98.8634 37.4082 96.8401 34.4251C96.8401 34.4251 94.8177 26.5942 95.2219 22.8655",
    fill: "#AFCDFB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M105.902 12.6763L104.37 22.2225C104.37 22.2225 108.649 24.0337 111.645 22.1441L111 15.4075L105.902 12.6763Z",
    fill: "#9E5A2E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M112.496 6.46023C112.545 6.54096 113.468 11.3544 114.036 14.3343C114.271 15.5652 113.289 16.709 111.935 16.7834L110.695 16.8505C108.418 16.9752 106.412 15.4805 106.067 13.4015L105.17 8.00372C105.17 8.00372 111.326 4.50271 112.496 6.46023",
    fill: "#B26634"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M103.834 8.01743C103.358 7.47229 102.944 6.59144 103.956 5.66504C104.98 4.72744 106.143 4.96085 106.88 5.27578C107.207 5.41486 107.609 5.35331 107.842 5.09993C107.945 4.98722 108.098 4.91129 108.325 4.93448C108.754 4.97924 109.137 4.71786 109.188 4.323C109.275 3.64598 109.667 2.84906 110.965 2.61805C113.346 2.19362 114.534 4.39094 114.492 5.93441C114.449 7.47869 111.839 7.8032 110.358 7.54742C109.27 7.35878 108.329 8.23964 107.907 8.72082C107.753 8.89587 107.696 9.12448 107.751 9.34349L108.127 10.835C107.867 11.2986 107.611 11.7718 107.244 12.1675C106.981 12.4528 106.692 12.6103 106.385 12.6766C105.941 11.9149 104.699 11.7854 104.121 11.7686C103.901 11.7622 103.695 11.6719 103.549 11.5184C103.114 11.0588 102.432 10.0317 103.737 9.02297C104.062 8.77279 104.098 8.32117 103.834 8.01743",
    fill: "url(#paint13_linear_3061_1304)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.814 14.2733C106.814 14.2733 106.763 11.5796 105.58 11.327C104.397 11.0736 103.122 11.8618 104.133 13.4748C105.391 15.4803 106.814 14.2733 106.814 14.2733",
    fill: "#B26634"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M102.142 35.7413C102.142 35.7413 67.4039 27.0256 84.6526 4.61286L85.8199 6.13555C85.8199 6.13555 80.6225 21.3161 97.8382 22.7589C97.8382 22.7589 102.297 33.3578 102.142 35.7413Z",
    fill: "#AFCDFB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5354 4.72801C84.5354 4.72801 84.1443 0.400528 86.4919 0.0400371C88.8396 -0.320454 89.6218 1.84329 90.0129 2.92476C90.4041 4.00704 86.4919 6.17078 85.7088 6.17078C84.9265 6.17078 84.5354 4.72801 84.5354 4.72801",
    fill: "#B26634"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M120.863 38.1346C120.863 38.1346 125.353 54.5133 147.876 36.4696L146.149 35.4985C146.149 35.4985 126.32 48.4641 122.825 26.3463C122.825 26.3463 120.863 36.1459 120.863 38.1346Z",
    fill: "#AFCDFB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M147.759 36.5855C147.759 36.5855 152.469 36.6567 152.704 34.4737C152.937 32.2908 150.542 31.7152 149.346 31.4275C148.148 31.1397 146.067 34.8822 146.119 35.6024C146.172 36.3218 147.759 36.5855 147.759 36.5855Z",
    fill: "#B26634"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M184.288 151.237C186.3 151.397 189.792 151.657 192.546 151.769C194.201 151.836 195.154 151.687 195.702 151.484C195.701 151.541 195.699 151.596 195.697 151.645C195.684 151.912 195.449 152.126 195.156 152.141C189.954 152.409 185.816 152.233 184.343 152.151C184.039 152.134 183.858 151.829 184.013 151.589C184.091 151.47 184.186 151.353 184.288 151.237",
    fill: "url(#paint14_linear_3061_1304)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M192.546 151.769C189.792 151.657 186.3 151.397 184.288 151.237C186.266 149 192.546 147.492 192.546 147.492H194.319C195.539 149.112 195.716 150.656 195.702 151.485C195.154 151.687 194.2 151.836 192.546 151.769Z",
    fill: "url(#paint15_linear_3061_1304)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M194.618 144.823L194.452 147.85C194.434 148.178 194.168 148.453 193.811 148.501C193.457 148.547 192.982 148.553 192.479 148.398C192.169 148.304 191.94 148.063 191.882 147.77L191.309 144.823H194.618",
    fill: "url(#paint16_linear_3061_1304)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M215.201 154.728C216.074 154.584 216.469 154.044 216.634 153.466C216.635 153.472 216.636 153.477 216.638 153.482C216.766 154.091 216.468 154.722 215.873 155.022C215.154 155.385 214.367 155.447 213.758 155.416C213.102 155.384 212.501 155.062 212.171 154.545L212.166 154.537C212.823 154.925 213.747 154.97 215.201 154.728Z",
    fill: "url(#paint17_linear_3061_1304)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M211.087 145.756H212.55C214.778 145.701 216.177 151.299 216.634 153.466C216.469 154.044 216.074 154.583 215.201 154.728C213.746 154.97 212.823 154.925 212.165 154.537C210.963 152.651 210.365 149.887 210.079 148.275C209.753 146.441 211.087 145.756 211.087 145.756Z",
    fill: "url(#paint18_linear_3061_1304)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M212.361 142.946L213.174 145.924C213.274 146.288 213.084 146.666 212.718 146.839C212.263 147.054 211.623 147.28 211.035 147.215C210.76 147.184 210.53 147.004 210.438 146.765L209.246 143.632L212.361 142.946",
    fill: "url(#paint19_linear_3061_1304)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M183.793 103.736C183.793 103.736 191.05 145.549 190.931 145.779C190.931 145.779 192.935 146.618 195.121 145.886C195.121 145.886 194.464 123.534 192.927 114.964C192.927 114.964 205.313 134.942 209.246 144.897C209.246 144.897 211.297 144.671 212.996 143.641C212.996 143.641 199.659 107.681 196.101 102.891L183.793 103.736",
    fill: "url(#paint20_linear_3061_1304)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M192.637 114.817C192.54 114.817 192.444 114.772 192.39 114.691L189.743 110.796L187.87 110.449C187.712 110.42 187.61 110.278 187.642 110.132C187.674 109.987 187.827 109.895 187.986 109.922L189.981 110.292C190.06 110.306 190.129 110.35 190.171 110.413L192.884 114.405C192.969 114.531 192.927 114.698 192.791 114.776C192.743 114.804 192.69 114.817 192.637 114.817",
    fill: "url(#paint21_linear_3061_1304)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M150.488 62.7916C150.488 62.7916 155.385 63.7876 158.363 65.0545C158.955 65.3063 159.427 65.7467 159.695 66.2895C160.587 68.088 163.252 72.5985 168.421 74.7511C167.677 75.6615 166.478 77.5551 165.956 80.7396C162.851 78.6094 160.171 75.0532 158.885 69.2198C158.885 69.2198 157.905 69.7106 156.683 69.1638C156.037 68.8745 155.291 68.4644 154.731 68.1423C154.174 67.821 153.758 67.3214 153.597 66.7379C153.384 65.9673 153.509 65.2903 153.509 64.5637L150.992 63.8443C150.992 63.8443 150.235 63.5814 150.488 62.7916",
    fill: "url(#paint22_linear_3061_1304)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M165.956 80.7396C166.478 77.5552 167.677 75.6616 168.421 74.7512C171.632 76.0876 175.809 76.5153 181.128 74.8167C181.619 74.66 182.129 74.5681 182.648 74.5402C185.48 74.3875 194.811 74.1077 202.532 76.4593C204.157 76.9541 205.473 78.0611 206.151 79.4959C208.24 83.9137 211.621 93.9738 202.234 99.0535C201.512 97.4029 200.681 96.076 199.969 95.1017C201.48 92.7517 201.928 89.5416 199.245 85.3612C197.289 90.2299 196.371 97.3333 196.18 100.477C196.116 101.511 196.313 102.545 196.754 103.5L196.802 103.605C196.897 103.809 196.767 104.044 196.53 104.093C191.245 105.187 185.748 104.89 184.106 104.765C183.813 104.742 183.57 104.55 183.502 104.288C180.933 94.3079 180.926 87.5002 181.556 83.1967C179.152 83.6923 171.801 84.749 165.956 80.7396",
    fill: "#233862"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M181.546 83.5365C181.533 83.5365 181.52 83.5357 181.507 83.5341C181.347 83.5149 181.235 83.3798 181.256 83.2328C181.876 78.9165 183.122 77.067 183.175 76.991C183.262 76.8655 183.443 76.8296 183.577 76.9079C183.713 76.987 183.754 77.1533 183.668 77.2788C183.656 77.2964 182.434 79.122 181.834 83.3031C181.814 83.4382 181.69 83.5365 181.546 83.5365",
    fill: "url(#paint23_linear_3061_1304)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M194.587 68.7267C194.587 68.7267 195.122 73.9367 195.592 75.4778C195.664 75.7112 195.553 75.9582 195.323 76.0797C194.524 76.5002 192.608 77.1868 189.987 76.0022C189.563 75.8103 189.308 75.4027 189.328 74.971L189.558 69.9361L194.587 68.7267",
    fill: "url(#paint24_linear_3061_1304)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M189.443 62.0612C189.443 62.0612 187.733 65.6821 187.618 67.582C187.503 69.482 187.059 70.7154 189.443 71.0983C191.827 71.4803 193.835 70.3861 194.923 68.4933C194.923 68.4933 196.627 65.5765 196.245 64.3824C195.862 63.1874 189.443 62.0612 189.443 62.0612",
    fill: "url(#paint25_linear_3061_1304)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M194.108 67.1322L193.972 67.0771C193.8 67.0067 193.726 66.8173 193.813 66.663C194.148 66.0643 194.804 64.6927 193.958 64.3722C192.867 63.9597 188.544 63.1476 187.612 61.7344C186.716 60.3764 187.51 58.6227 188.703 58.1239C188.783 58.0904 188.877 58.1167 188.918 58.1887L189.018 58.3621C189.085 58.4804 189.276 58.4628 189.316 58.3334C189.355 58.2095 189.534 58.1855 189.608 58.295C189.895 58.7178 190.669 59.4036 192.738 59.7553C195.679 60.2557 197.623 61.3524 197.672 63.226C197.675 63.3443 197.813 63.4106 197.923 63.3491C198.139 63.2268 198.487 63.17 198.951 63.5297C199.759 64.1556 199.428 65.779 197.658 67.1146C197.574 67.1786 197.575 67.2993 197.666 67.3536C197.987 67.5462 198.466 68.0051 197.225 68.6157C195.943 69.2472 194.985 69.196 194.617 69.1393C194.525 69.1257 194.466 69.0434 194.486 68.9602L194.88 67.3136C194.901 67.2209 194.825 67.1322 194.721 67.1322H194.108",
    fill: "url(#paint26_linear_3061_1304)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M194.034 67.4799C194.034 67.4799 194.686 65.1674 195.811 65.8157C196.937 66.464 195.228 68.4072 194.323 68.4935L194.034 67.4799",
    fill: "url(#paint27_linear_3061_1304)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M157.578 68.7531C157.493 68.7531 157.409 68.7195 157.352 68.6539C156.649 67.8562 155.45 66.591 155.034 66.3735C154.666 66.1825 154.457 65.9675 154.393 65.7165C154.338 65.5039 154.396 65.2809 154.563 65.0523C154.629 64.962 154.743 64.918 154.862 64.9388L157 65.3336C157.049 65.3424 157.095 65.3632 157.133 65.3928L158.269 66.292C158.391 66.3887 158.405 66.559 158.301 66.6709C158.195 66.7844 158.011 66.7964 157.889 66.7004L156.81 65.8468L154.964 65.5055C154.951 65.5534 154.958 65.5806 154.961 65.5934C154.985 65.6869 155.112 65.7972 155.32 65.906C155.966 66.2417 157.618 68.104 157.805 68.315C157.906 68.4301 157.887 68.5996 157.762 68.6931C157.709 68.7331 157.643 68.7531 157.578 68.7531",
    fill: "url(#paint28_linear_3061_1304)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M194.082 102.611L186.366 102.456C186.366 102.456 193.095 100.703 193.512 101.18C193.512 101.18 197.682 98.6546 199.968 95.1017C200.681 96.076 201.512 97.4029 202.234 99.0535C200.185 100.162 197.494 102.088 194.082 102.611Z",
    fill: "url(#paint29_linear_3061_1304)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M194.299 101.38C194.299 101.38 194.459 104.214 190.423 103.802C188.229 103.578 184.688 101.694 184.688 101.694C184.688 101.694 193.919 101.671 194.299 101.38Z",
    fill: "url(#paint30_linear_3061_1304)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M180.419 166.095C181.05 172.518 183.592 211.943 151.988 220.213C151.032 220.463 149.879 219.889 149.863 219.155C149.754 214.482 150.677 199.8 164.703 184.193C174.823 172.932 178.62 167.753 179.83 165.971C179.959 165.781 180.397 165.875 180.419 166.095",
    fill: "#91B3FA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M174.878 179.267V179.268V179.267ZM174.879 179.269V179.27V179.269ZM149.863 219.699C149.72 219.699 149.576 219.651 149.463 219.555C149.223 219.351 149.208 219.007 149.429 218.786C166.196 202.026 174.603 180.498 174.85 179.123C174.839 178.885 174.998 178.661 175.255 178.583C175.565 178.489 175.898 178.644 176.001 178.929C176.049 179.064 176.178 179.426 174.482 183.369C173.57 185.492 171.996 188.91 169.678 193.143C165.81 200.206 159.308 210.517 150.296 219.524C150.18 219.64 150.021 219.699 149.863 219.699Z",
    fill: "#BDD0FB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M193.633 201.867C190.937 205.907 173.606 230.169 151.035 222.22C150.352 221.978 149.947 221.174 150.287 220.734C152.456 217.936 160.011 209.66 175.73 206.154C187.07 203.625 191.781 202.115 193.345 201.555C193.511 201.496 193.725 201.729 193.633 201.867",
    fill: "#BDD0FB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M183.929 207.336C183.928 207.337 183.928 207.337 183.928 207.337C183.928 207.337 183.928 207.337 183.929 207.336ZM150.287 221.277C150.008 221.277 149.76 221.095 149.707 220.833C149.648 220.538 149.859 220.254 150.18 220.198C167.866 217.16 183.056 208.001 184.011 207.188C184.159 207.002 184.425 206.916 184.675 206.994C184.984 207.089 185.151 207.397 185.048 207.682C184.825 208.297 179.48 211.271 174.456 213.575C168.795 216.171 160.025 219.614 150.396 221.269C150.36 221.275 150.323 221.277 150.287 221.277",
    fill: "url(#paint31_linear_3061_1304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3061_1304",
    x1: 91.2384,
    y1: 91.9251,
    x2: 94.5014,
    y2: 52.9822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3061_1304",
    x1: 82.3873,
    y1: 91.1819,
    x2: 85.6504,
    y2: 52.2381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3061_1304",
    x1: 221.996,
    y1: 132.662,
    x2: 168.168,
    y2: 221.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7976F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3061_1304",
    x1: 9.18171,
    y1: 160.839,
    x2: 17.8166,
    y2: 183.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3061_1304",
    x1: 13.0375,
    y1: 166.625,
    x2: 26.0607,
    y2: 187.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3061_1304",
    x1: 41.1104,
    y1: 155.139,
    x2: 33.297,
    y2: 130.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3061_1304",
    x1: 28.1827,
    y1: 109.345,
    x2: 39.7907,
    y2: 120.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3061_1304",
    x1: 33.8747,
    y1: 102.674,
    x2: 33.817,
    y2: 124.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3061_1304",
    x1: 105.881,
    y1: 109.355,
    x2: 97.7548,
    y2: 109.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3061_1304",
    x1: 98.9354,
    y1: 42.0778,
    x2: 100.189,
    y2: 77.8497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3061_1304",
    x1: 124.41,
    y1: 90.8861,
    x2: 123.156,
    y2: 126.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3061_1304",
    x1: 117.831,
    y1: 109.462,
    x2: 129.267,
    y2: 109.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3061_1304",
    x1: 140.222,
    y1: 47.433,
    x2: 88.3681,
    y2: 121.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3061_1304",
    x1: 102.782,
    y1: 10.357,
    x2: 113.821,
    y2: 3.75345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3061_1304",
    x1: 195.703,
    y1: 151.76,
    x2: 183.957,
    y2: 151.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392065,
    stopColor: "#23286C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3061_1304",
    x1: 195.703,
    y1: 149.639,
    x2: 184.288,
    y2: 149.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3061_1304",
    x1: 194.618,
    y1: 146.676,
    x2: 191.309,
    y2: 146.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3061_1304",
    x1: 216.667,
    y1: 154.445,
    x2: 212.166,
    y2: 154.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392065,
    stopColor: "#23286C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3061_1304",
    x1: 216.634,
    y1: 150.317,
    x2: 210.028,
    y2: 150.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3061_1304",
    x1: 213.2,
    y1: 145.086,
    x2: 209.246,
    y2: 145.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3061_1304",
    x1: 209.482,
    y1: 94.0186,
    x2: 185.792,
    y2: 168.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392065,
    stopColor: "#23286C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3061_1304",
    x1: 223.906,
    y1: 48.411,
    x2: 187.521,
    y2: 129.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392065,
    stopColor: "#23286C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3061_1304",
    x1: 158.813,
    y1: 68.3213,
    x2: 172.904,
    y2: 88.2113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3061_1304",
    x1: 264.789,
    y1: 25.584,
    x2: 223.049,
    y2: 58.1917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3061_1304",
    x1: 193.72,
    y1: 80.4584,
    x2: 192.257,
    y2: 72.1242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3061_1304",
    x1: 189.085,
    y1: 65.248,
    x2: 198.26,
    y2: 72.8648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3061_1304",
    x1: 195.965,
    y1: 59.7897,
    x2: 187.767,
    y2: 71.2417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3061_1304",
    x1: 190.297,
    y1: 63.7877,
    x2: 199.473,
    y2: 71.4046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3061_1304",
    x1: 164.977,
    y1: 57.2184,
    x2: 155.53,
    y2: 69.4019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3061_1304",
    x1: 186.42,
    y1: 89.4522,
    x2: 191.417,
    y2: 97.5836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3061_1304",
    x1: 197.61,
    y1: 90.7058,
    x2: 192.715,
    y2: 98.6733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3061_1304",
    x1: 149.698,
    y1: 214.121,
    x2: 185.079,
    y2: 214.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.139e9703.svg";
export { ForwardRef as ReactComponent };